import React, { useEffect } from "react";

export default function StorySheet({ children, footer, testId, title, onClose }) {
  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  useEffect(() => {
    const closeOnEscape = (event) => event.key === "Escape" && onClose();
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [onClose]);

  return (
    <div className="story-sheet-backdrop" onClick={onClose}>
      <div aria-label={title} aria-modal="true" className="story-sheet" data-testid={testId} role="dialog" onClick={(event) => event.stopPropagation()}>
        <div className="story-sheet-header">
          <h2>{title}</h2>
          <button aria-label="Close" className="story-icon-button" type="button" onClick={onClose}>
            <span className="fa fa-times" />
          </button>
        </div>
        <div className="story-sheet-body">{children}</div>
        {!!footer && <div className="story-sheet-footer">{footer}</div>}
      </div>
    </div>
  );
}
